module.exports = __webpack_public_path__ + "img/001-food.7afa68c2.png";